var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.esm = leica.pi.esm || {};

leica.pi.esm.columnNavigator = (function() {
	"use strict";
	var cn = {};
	// Cache the $(window) reference for use during scroll events. 
	var $window = $(window);
		
	// update column navigation column scrolling (< or >) and column position display.
	cn.updateControls = function($section) {

		var $navDiv = $section.find('.column-scrolling');
		if ($navDiv.length == 0) {
			// No navigation controls for this section
			return;
		}

		// Update column indicator & scroll buttons
		var $listing = leica.pi.esm.listScrollbar.getListDiv($section);
		var visibleColumns = getVisibleColumns($listing);

		var startColumn = visibleColumns.dispFirstIndex;
		var lastColumn = visibleColumns.dispLastIndex;
		if (visibleColumns.listFirstIndex === 0) {
			// Make column numbers user-friendly
			startColumn++;
			lastColumn++;
		}

		// Update nav buttons and description
		$navDiv.find('.columns-visible').text(startColumn + '-' + lastColumn);
		$navDiv.find('.column-count').text(visibleColumns.totalCount);
		$navDiv.find('.column-scroll').removeClass('Disabled');
		if (visibleColumns.dispFirstIndex === visibleColumns.listFirstIndex) {
			$navDiv.find('.column-scroll:first').addClass('Disabled');
		}
		if (visibleColumns.dispLastIndex === visibleColumns.listLastIndex) {
			$navDiv.find('.column-scroll:last').addClass('Disabled');
		}
	}

	// scrollToColumns
	function jump($button) {
		var $section = leica.pi.esm.listScrollbar.getSection($button);
		var $listing = leica.pi.esm.listScrollbar.getListDiv($section);
		var $tableHeader = $listing.find('thead tr:not(.tableFloatingHeader):first');
		var visibleWidth = $listing.width();
		var	visibleColumns = getVisibleColumns($listing);
		var	leftPos = 0;

		var direction = $button.data('direction');
		if (direction === 'previous') {
			var $next = $tableHeader.find('th:eq(' + visibleColumns.dispFirstIndex + ')');
			if ($next.length > 0) {
				leftPos = $next.position().left - visibleWidth;
			}
		} else {
			var tableWidth = $tableHeader.width();
			if (visibleColumns.dispLastIndex < visibleColumns.listLastIndex) {
				var $next = $tableHeader.find('th:eq(' + (visibleColumns.dispLastIndex+1) + ')');
				var fixedColWidth = getFixedColWidth($listing);
				leftPos = $next.position().left - fixedColWidth;
				if (leftPos > (tableWidth - visibleWidth)) {
					// Push list against the right margin
					leftPos = tableWidth - visibleWidth;
				}
			} else {
				// Already displaying the last column, ensure the list is against the right margin
				leftPos = tableWidth - visibleWidth;
			}
		}

		var $section = leica.pi.esm.listScrollbar.getSection($listing);
		leica.pi.esm.listScrollbar.scrollSection($section, leftPos);
	}

	function getFixedColWidth($listing) {
		var fixedWidth = $listing.find('td.fixed-column:first').width();
		if (!fixedWidth) {
			// When fixed column <td> is not present for tables that do not have any data then
			// look for fixed column <th> and for tables that do not have <th> with fixed column, make fixedwidth zero
			var thWidth = $listing.find('th.fixed-column:first').width();
			fixedWidth = (thWidth) ? thWidth : 0;
		}
		return fixedWidth;
	}

	// column to visible on left and right click for column navigation 
	// @return e.g. visibleColumns = Object {listFirstIndex: 1, listLastIndx: 16, totalCount: 16, dispFirstIndex: 0, dispLastIndex: 8}
	function getVisibleColumns($listing) {

		var visibleColumns = {dispFirstIndex: -1};
		var fixedWidth = getFixedColWidth($listing);

		var $tableHeader = $listing.find('thead tr:not(.tableFloatingHeader):first');
		var $columns = $tableHeader.find('th');

		visibleColumns.listFirstIndex = 0;
		visibleColumns.listLastIndex = $columns.length - 1;
		visibleColumns.totalCount = $columns.length;
		if (fixedWidth > 0) {
			// The fixed column is index 0 - don't include it other than offset calculations
			visibleColumns.listFirstIndex = 1;
			visibleColumns.totalCount--;
		}

		var windowWidth = $window.width();
		var domWidth = $('#foundation').width();

		// The following column comparisons use the columns' visible positions.  Offset those positions with the windows scroll position.
		// windows will only produce horizontal scrollbar when the window width is below the minimum width
		var windowsScrollLeft = $window.scrollLeft();
		var fixedRight = fixedWidth - windowsScrollLeft;
		var viewWidth = windowWidth >= domWidth ? windowWidth : domWidth;
		viewWidth -= windowsScrollLeft;
		viewWidth --;	// Allow last column to be a little over (plus avoid floating point rounding)
		for (var index = visibleColumns.listFirstIndex; index <= visibleColumns.listLastIndex; index++)  {
			var bounds = $columns.get(index).getBoundingClientRect();
			if ((visibleColumns.dispFirstIndex === -1) && (bounds.left >= fixedRight)) {
				visibleColumns.dispFirstIndex = index;
			}
			if (bounds.right > viewWidth) {
				break;
			}
		}
		visibleColumns.dispLastIndex = index - 1;
		return visibleColumns;
	}

	cn.initialize = function($section) {

		if ((typeof $section === 'undefined') || !$section.length) {
			return;
		}

		// Unbind the previous attached click events, bind new events
		var $button = $section.find('.column-scroll')
		var id = $section.attr('id');
		$button.data('section-id', id);
		$button.off('.columnScroll');
		$button.on('click.columnScroll', function(event) {
			event.preventDefault();
			jump($(this));
		});
	}
	
	return cn;
}());

